import { RCS } from "./rcs";

const CONSEQUENCES = [
	{
		id: "conseq1",
		domainCode: "consequences",
		code: "1",
		description:
			"Impact on the safety of patients, staff or public (physical and/or psychological harm)",
	},
	{
		id: "conseq2",
		domainCode: "consequences",
		code: "2",
		description: "Quality/Complaints/Audit",
	},
	{
		id: "conseq3",
		domainCode: "consequences",
		code: "3",
		description:
			"Human resources / organisational development / staffing / competence",
	},
	{
		id: "conseq4",
		domainCode: "consequences",
		code: "4",
		description: "Statutory duty / Inspections",
	},
	{
		id: "conseq5",
		domainCode: "consequences",
		code: "5",
		description: "Adverse publicity / Reputation",
	},
	{
		id: "conseq6",
		domainCode: "consequences",
		code: "6",
		description: "Business objectives / Projects",
	},
	{
		id: "conseq7",
		domainCode: "consequences",
		code: "7",
		description: "Finance including claims",
	},
	{
		id: "conseq8",
		domainCode: "consequences",
		code: "8",
		description: "Service / business interruption / Environmental impact",
	},
	{
		id: "conseq9",
		domainCode: "consequences",
		code: "9",
		description: "Information Systems",
	},
];

const WEIGHTING = [
	{
		id: "1",
		domainCode: "weighting",
		code: "1",
		description: "1 - Insignificant",
	},
	{
		id: "2",
		domainCode: "weighting",
		code: "2",
		description: "2 - Minor",
	},
	{
		id: "3",
		domainCode: "weighting",
		code: "3",
		description: "3 - Moderate",
	},
	{
		id: "4",
		domainCode: "weighting",
		code: "4",
		description: "4 - Major",
	},
	{
		id: "5",
		domainCode: "weighting",
		code: "5",
		description: "5 - Catastrophic",
	},
];

const LIKELIHOOD_CONSEQUENCE = [
	{
		id: "lc1",
		domainCode: "likelihoodOfConsequence",
		code: "1",
		description:
			"1-Rare (The event may occur only in exceptional circumstances)",
	},
	{
		id: "lc2",
		domainCode: "likelihoodOfConsequence",
		code: "2",
		description: "2-Unlikely (The event could occur at some time)",
	},
	{
		id: "lc3",
		domainCode: "likelihoodOfConsequence",
		code: "3",
		description: "3-Possible (The event will occur at some time)",
	},
	{
		id: "lc4",
		domainCode: "likelihoodOfConsequence",
		code: "4",
		description:
			"4-Likely (The event will probably occur in most circumstances)",
	},
	{
		id: "lc5",
		domainCode: "likelihoodOfConsequence",
		code: "5",
		description:
			"5-Almost Certain (The event is expected to occur in most circumstances)",
	},
];

const LIKELIHOOD_FAILURE = [
	{
		id: "lf1",
		domainCode: "likelihoodOfAssetFailing",
		code: "1",
		description:
			"(1)Rare - Failure is not expected to occur for years.  New or some wear or discoloration but no evidence of damage",
	},
	{
		id: "lf2",
		domainCode: "likelihoodOfAssetFailing",
		code: "2",
		description:
			"(2)Unlikely - Failure could occur in the next year. Acceptable physical condition, with minor deterioration or damage that may affect performance (includes most repaired assets)",
	},
	{
		id: "lf3",
		domainCode: "likelihoodOfAssetFailing",
		code: "3",
		description:
			"(3)Possible - Failure is expected to occur in the next six months.  Some deterioration is evident but asset is still serviceable",
	},
	{
		id: "lf4",
		domainCode: "likelihoodOfAssetFailing",
		code: "4",
		description:
			"(4)Likely - Failure will probably occur in the next month.  Significant deterioration or damage is evident and may be impacting performance or suggests that the asset may be likely to fail in the short term",
	},
	{
		id: "lf5",
		domainCode: "likelihoodOfAssetFailing",
		code: "5",
		description:
			"(5)Almost certain - Immediate repair or renewal is required. Asset is unserviceable (i.e. has failed) or failure is considered imminent (in the next week)",
	},
];

const SERVICE_IMPACT = [
	{
		id: "si1",
		domainCode: "serviceImpact",
		code: "1",
		description:
			"(1)None - No impact on the delivery of the service, due to a redundancy in assets (via an asset fleet/pool) or a local workaround",
	},
	{
		id: "si2",
		domainCode: "serviceImpact",
		code: "2",
		description:
			"(2)Minor - Minor impact on the ability to deliver the service, and/or waiting times increased to between 12 to 24 hours",
	},
	{
		id: "si3",
		domainCode: "serviceImpact",
		code: "3",
		description:
			"(3)Moderate - Considerable impact on the  ability to deliver the service, and/or waiting times increased beyond 24 hours",
	},
	{
		id: "si4",
		domainCode: "serviceImpact",
		code: "4",
		description:
			"(4)Significant - Significant impact on the ability to deliver the service, and/or major disruption resulting in multiple cancelations",
	},
	{
		id: "si5",
		domainCode: "serviceImpact",
		code: "5",
		description:
			"(5)Major - Major impact on the ability to deliver the service for an indefinite period resulting in the service having to be outsourced, and/or no alternative to deliver the service",
	},
];

const PATIENT_STAFF_IMPACT = [
	{
		id: "psi1",
		domainCode: "patientStaffImpact",
		code: "1",
		description:
			"(1)None - Minimal injury requiring no or minimal additional intervention or treatment, and/or no impact on patient experience.",
	},
	{
		id: "psi2",
		domainCode: "patientStaffImpact",
		code: "2",
		description:
			"(2)Minor - Minor injury or illness, requiring minor intervention, and/or increase in length of hospital stay by 1-3 days, and/or minor impact on patient experience.",
	},
	{
		id: "psi3",
		domainCode: "patientStaffImpact",
		code: "3",
		description:
			"(3)Moderate - Moderate injury requiring professional intervention, and/or increase in length of hospital stay by 4-15 days, and/or moderate impact on patient experience.",
	},

	{
		id: "psi4",
		domainCode: "patientStaffImpact",
		code: "4",
		description:
			"(4)Significant - Significant injury leading to long-term incapacity/disability, and/or increase in length of hospital stay by >15 days, and/or mismanagement of patient care with long-term effects, and/or significant impact on patient experience.",
	},
	{
		id: "psi5",
		domainCode: "patientStaffImpact",
		code: "5",
		description:
			"(5)Major - Incident leading to unexpected death; multiple permanent injuries or irreversible health effects, and/or impacts on large number of patients / staff, and/or major impact on patient experience.",
	},
];

const PROJECT_TYPE = [
	{
		id: "l1",
		domainCode: "projectType",
		code: "purchaseListedItem",
		description: "Request to purchase listed items only (individual asset)",
	},
	{
		id: "l2",
		domainCode: "projectType",
		code: "project",
		description:
			"Request to create a Project in which something is built or created (major project)",
	},
];

const REQUEST_DETAILS = [
	{
		id: "l3",
		domainCode: "requestDetails",
		code: "newRequest",
		description: "New request",
	},
	{
		id: "l4",
		domainCode: "requestDetails",
		code: "supplementaryFundingRequest",
		description: "Supplementary funding request",
	},
];

const CAPABILITY_TYPE = [
	{
		id: "l5",
		domainCode: "capabilityType",
		code: "yes",
		description: "Creates new capability or increased capacity",
	},
	{
		id: "l6",
		domainCode: "capabilityType",
		code: "no",
		description: "Replaces an existing item(s) like for like",
	},
];

const CURRENCY = [
	{
		id: "l7",
		domainCode: "currency",
		code: "NZD",
		description: "NZD",
	},
	{
		id: "l8",
		domainCode: "currency",
		code: "AUD",
		description: "AUD",
	},
	{
		id: "l9",
		domainCode: "currency",
		code: "USD",
		description: "USD",
	},
];

const COST_TYPE = [
	{
		id: "l10",
		domainCode: "costType",
		code: "maint",
		description: "Maintenance Costs",
	},
	{
		id: "l11",
		domainCode: "costType",
		code: "cons",
		description: "Consumable Costs",
	},
	{
		id: "l12",
		domainCode: "costType",
		code: "staff",
		description: "Staff Costs",
	},
	{
		id: "l13",
		domainCode: "costType",
		code: "other",
		description: "Other Costs",
	},
];

const ORACLE_SETUP_TYPE = [
	{
		id: "T-Build Activity-WT",
		domainCode: "FPIMSetupType",
		code: "T-Build Activity-WT",
		description: "T-Build Activity-WT",
	},
	{
		id: "T-Clinical Equipment-WT",
		domainCode: "FPIMSetupType",
		code: "T-Clinical Equipment-WT",
		description: "T-Clinical Equipment-WT",
	},
	{
		id: "T-General Equipment-WT",
		domainCode: "FPIMSetupType",
		code: "T-General Equipment-WT",
		description: "T-General Equipment-WT",
	},
	{
		id: "T-Intangible Assets-WT",
		domainCode: "FPIMSetupType",
		code: "T-Intangible Assets-WT",
		description: "T-Intangible Assets-WT",
	},
	{
		id: "T-IT Devices-WT",
		domainCode: "FPIMSetupType",
		code: "T-IT Devices-WT",
		description: "T-IT Devices-WT",
	},
	{
		id: "T-IT Project-WT",
		domainCode: "FPIMSetupType",
		code: "T-IT Project-WT",
		description: "T-IT Project-WT",
	},
	{
		id: "T-Land-WT",
		domainCode: "FPIMSetupType",
		code: "T-Land-WT",
		description: "T-Land-WT",
	},
	{
		id: "T-Leased Land Buildgs-WT",
		domainCode: "FPIMSetupType",
		code: "T-Leased Land Buildgs-WT",
		description: "T-Leased Land Buildgs-WT",
	},
	{
		id: "T-Motor Vehicles-WT",
		domainCode: "FPIMSetupType",
		code: "T-Motor Vehicles-WT",
		description: "T-Motor Vehicles-WT",
	},
	{
		id: "T-Opex Project-WT",
		domainCode: "FPIMSetupType",
		code: "T-Opex Project-WT",
		description: "T-Opex Project-WT",
	},
	{
		id: "T-Seed-WT",
		domainCode: "FPIMSetupType",
		code: "T-Seed-WT",
		description: "T-Seed-WT",
	},
];

const BUDGET_CATEGORIES = [
	{
		id: "WT-23-C-01001",
		domainCode: "budgetCategories",
		code: "WT-23-C-01001",
		description: "FY22 Carry-forward",
		inactive: true,
	},
	{
		id: "WT-23-C-01002",
		domainCode: "budgetCategories",
		code: "WT-23-C-01002",
		description: "FY22 Carry-forward (Mental Health)",
		inactive: true,
	},
	{
		id: "WT-23-C-01003",
		domainCode: "budgetCategories",
		code: "WT-23-C-01003",
		description: "Covid projects (DHB-funded)",
		inactive: true,
	},
	{
		id: "WT-23-C-01004",
		domainCode: "budgetCategories",
		code: "WT-23-C-01004",
		description: "Inflight replacement projects",
		inactive: true,
	},
	{
		id: "WT-23-C-01005",
		domainCode: "budgetCategories",
		code: "WT-23-C-01005",
		description: "Replacement pipeline projects",
		inactive: true,
	},
	{
		id: "WT-23-C-01006",
		domainCode: "budgetCategories",
		code: "WT-23-C-01006",
		description: "Critical Clinical Equipment",
		inactive: true,
	},
	{
		id: "WT-23-C-01007",
		domainCode: "budgetCategories",
		code: "WT-23-C-01007",
		description: "Reactive Replacement",
		inactive: true,
	},
	{
		id: "WT-23-C-01008",
		domainCode: "budgetCategories",
		code: "WT-23-C-01008",
		description: "Clinical Fleet assets",
		inactive: true,
	},
	{
		id: "WT-23-C-01009",
		domainCode: "budgetCategories",
		code: "WT-23-C-01009",
		description: "Facilities",
		inactive: true,
	},
	{
		id: "WT-23-C-01010",
		domainCode: "budgetCategories",
		code: "WT-23-C-01010",
		description: "IT IS",
		inactive: true,
	},
	{
		id: "WT-23-C-01011",
		domainCode: "budgetCategories",
		code: "WT-23-C-01011",
		description: "Hospital Services Minor",
		inactive: true,
	},
	{
		id: "WT-23-C-01012",
		domainCode: "budgetCategories",
		code: "WT-23-C-01012",
		description: "Mental Health Minor",
		inactive: true,
	},
	{
		id: "WT-23-C-01013",
		domainCode: "budgetCategories",
		code: "WT-23-C-01013",
		description: "Facilities Maintenance Minor",
		inactive: true,
	},
	{
		id: "WT-23-C-01014",
		domainCode: "budgetCategories",
		code: "WT-23-C-01014",
		description: "Corporate Minor",
		inactive: true,
	},
	{
		id: "WT-23-C-01015",
		domainCode: "budgetCategories",
		code: "WT-23-C-01015",
		description: "Inflight Strategic projects",
		inactive: true,
	},
	{
		id: "WT-23-C-01016",
		domainCode: "budgetCategories",
		code: "WT-23-C-01016",
		description: "Strategic pipeline projects",
		inactive: true,
	},
	{
		id: "WT-23-C-01017",
		domainCode: "budgetCategories",
		code: "WT-23-C-01017",
		description: "Strategic Minor",
		inactive: true,
	},
	{
		id: "WT-23-C-01018",
		domainCode: "budgetCategories",
		code: "WT-23-C-01018",
		description: "PC Fund",
		inactive: true,
	},
	{
		id: "WT-23-C-01019",
		domainCode: "budgetCategories",
		code: "WT-23-C-01019",
		description: "Facilities (non-replacement/new)",
		inactive: true,
	},
	{
		id: "WT-23-C-01020",
		domainCode: "budgetCategories",
		code: "WT-23-C-01020",
		description: "IT IS (non-replacement/new)",
		inactive: true,
	},
	{
		id: "WT-23-C-01021",
		domainCode: "budgetCategories",
		code: "WT-23-C-01021",
		description: "Mental Health (non-replacement/new)",
		inactive: true,
	},
	{
		id: "WT-23-C-01022",
		domainCode: "budgetCategories",
		code: "WT-23-C-01022",
		description: "Clinical Equipment (non-replacement/new)",
		inactive: true,
	},
	{
		id: "WT-23-C-01023",
		domainCode: "budgetCategories",
		code: "WT-23-C-01023",
		description: "Escalation",
		inactive: true,
	},
	{
		id: "WT-23-C-01024",
		domainCode: "budgetCategories",
		code: "WT-23-C-01024",
		description: "Well Foundation",
		inactive: true,
	},
	{
		id: "Cash Reserves",
		domainCode: "budgetCategories",
		code: "Cash Reserves",
		description: "Cash Reserves",
		inactive: true,
	},
	{
		id: "Three Harbours Trust",
		domainCode: "budgetCategories",
		code: "Three Harbours Trust",
		description: "Three Harbours Trust",
		inactive: true,
	},

	{
		id: "Carry-forward from FY23",
		domainCode: "budgetCategories",
		code: "Carry-forward from FY23",
		description: "Carry-forward from FY23",
	},
	{
		id: "Change Requests",
		domainCode: "budgetCategories",
		code: "Change Requests",
		description: "Change Requests",
	},
	{
		id: "Clinical Equipment - ARDS",
		domainCode: "budgetCategories",
		code: "Clinical Equipment - ARDS",
		description: "Clinical Equipment - ARDS",
	},
	{
		id: "Clinical Equipment - Fleet Replacement",
		domainCode: "budgetCategories",
		code: "Clinical Equipment - Fleet Replacement",
		description: "Clinical Equipment - Fleet Replacement",
	},
	{
		id: "Clinical Equipment - Growth / Expansion",
		domainCode: "budgetCategories",
		code: "Clinical Equipment - Growth / Expansion",
		description: "Clinical Equipment - Growth / Expansion",
	},
	{
		id: "Clinical Equipment - Planned Replacement",
		domainCode: "budgetCategories",
		code: "Clinical Equipment - Planned Replacement",
		description: "Clinical Equipment - Planned Replacement",
	},
	{
		id: "Clinical Equipment - Reactive Replacement",
		domainCode: "budgetCategories",
		code: "Clinical Equipment - Reactive Replacement",
		description: "Clinical Equipment - Reactive Replacement",
	},
	{
		id: "Corporate Minor",
		domainCode: "budgetCategories",
		code: "Corporate Minor",
		description: "Corporate Minor",
	},
	{
		id: "Crown",
		domainCode: "budgetCategories",
		code: "Crown",
		description: "Crown",
	},
	{
		id: "Facilities Minor",
		domainCode: "budgetCategories",
		code: "Facilities Minor",
		description: "Facilities Minor",
	},
	{
		id: "FY25 Top-slice",
		domainCode: "budgetCategories",
		code: "FY25 Top-slice",
		description: "FY25 Top-slice",
	},
	{
		id: "IT Hardware",
		domainCode: "budgetCategories",
		code: "IT Hardware",
		description: "IT Hardware",
	},
	{
		id: "Major Capex",
		domainCode: "budgetCategories",
		code: "Major Capex",
		description: "Major Capex",
	},
	{
		id: "Management Reserve",
		domainCode: "budgetCategories",
		code: "Management Reserve",
		description: "Management Reserve",
	},
	{
		id: "Mental Health Minor",
		domainCode: "budgetCategories",
		code: "Mental Health Minor",
		description: "Mental Health Minor",
	},
	{
		id: "Minor Capex",
		domainCode: "budgetCategories",
		code: "Minor Capex",
		description: "Minor Capex",
	},
	{
		id: "Other",
		domainCode: "budgetCategories",
		code: "Other",
		description: "Other",
	},
	{
		id: "Well Foundation",
		domainCode: "budgetCategories",
		code: "Well Foundation",
		description: "Well Foundation",
	},
	{
		id: "WT Project",
		domainCode: "budgetCategories",
		code: "WT Project",
		description: "WT Project",
	},
];

const END_USER_CODE = [
	{
		id: "NS-01",
		domainCode: "endUserCode",
		code: "NS-01",
		description: "NS-01 North Shore Hospital : Tahoroto Mental Health Unit",
	},
	{
		id: "01 NSSFQ4 ",
		domainCode: "endUserCode",
		code: "01 NSSFQ4 ",
		description: "01 NSSFQ4 : North Shore Smales Farm",
	},
	{
		id: "NS-02",
		domainCode: "endUserCode",
		code: "NS-02",
		description: "NS-02 North Shore Hospital : Groundsmen Quarters",
	},
	{
		id: "NS-03",
		domainCode: "endUserCode",
		code: "NS-03",
		description: "NS-03 North Shore Hospital : Trades Workshops",
	},
	{
		id: "NS-04",
		domainCode: "endUserCode",
		code: "NS-04",
		description: "NS-04 North Shore Hospital : Boiler House",
	},
	{
		id: "NS-05-GR",
		domainCode: "endUserCode",
		code: "NS-05-GR",
		description:
			"NS-05-GR North Shore Hospital : Outpatients, Ground Floor",
	},
	{
		id: "NS-05-01",
		domainCode: "endUserCode",
		code: "NS-05-01",
		description:
			"NS-05-01 North Shore Hospital : Community Health, 01 Floor",
	},
	{
		id: "NS-06-11",
		domainCode: "endUserCode",
		code: "NS-06-11",
		description:
			"NS-06-11 North Shore Hospital : Geriatric Block - Ward 11",
	},
	{
		id: "NS-06-12",
		domainCode: "endUserCode",
		code: "NS-06-12",
		description:
			"NS-06-12 North Shore Hospital : Geriatric Block - Ward 12",
	},
	{
		id: "NS-06-14",
		domainCode: "endUserCode",
		code: "NS-06-14",
		description:
			"NS-06-14 North Shore Hospital : Geriatric Block - Ward 14",
	},
	{
		id: "NS-06-15",
		domainCode: "endUserCode",
		code: "NS-06-15",
		description:
			"NS-06-15 North Shore Hospital : Geriatric Block - Ward 15",
	},
	{
		id: "NS-07",
		domainCode: "endUserCode",
		code: "NS-07",
		description: "NS-07 North Shore Hospital : Lakeside Pump House",
	},
	{
		id: "NS-08",
		domainCode: "endUserCode",
		code: "NS-08",
		description: "NS-08 North Shore Hospital : Pupuke Centre",
	},
	{
		id: "NS-09",
		domainCode: "endUserCode",
		code: "NS-09",
		description: "NS-09 North Shore Hospital : Blood Service",
	},
	{
		id: "NS-10",
		domainCode: "endUserCode",
		code: "NS-10",
		description: "NS-10 North Shore Hospital : Marinoto",
	},
	{
		id: "NS-11",
		domainCode: "endUserCode",
		code: "NS-11",
		description:
			"NS-11 North Shore Hospital : Stepping Stones;  Living Skills",
	},
	{
		id: "NS-12",
		domainCode: "endUserCode",
		code: "NS-12",
		description:
			"NS-12 North Shore Hospital : Marinoto North - 124A Shakespeare Rd",
	},
	{
		id: "NS-13",
		domainCode: "endUserCode",
		code: "NS-13",
		description:
			"NS-13 North Shore Hospital : Diabetes Unit - 124B Shakespeare Rd",
	},
	{
		id: "NS-14",
		domainCode: "endUserCode",
		code: "NS-14",
		description: "NS-14 North Shore Hospital : Raeburn House",
	},
	{
		id: "NS-15-LG",
		domainCode: "endUserCode",
		code: "NS-15-LG",
		description:
			"NS-15-LG North Shore Hospital : Main Building, Lower Ground Floor",
	},
	{
		id: "NS-15-GR",
		domainCode: "endUserCode",
		code: "NS-15-GR",
		description:
			"NS-15-GR North Shore Hospital : Main Building, Ground Floor",
	},
	{
		id: "NS-15-01",
		domainCode: "endUserCode",
		code: "NS-15-01",
		description: "NS-15-01 North Shore Hospital : Main Building, 01 Floor",
	},
	{
		id: "NS-15-02",
		domainCode: "endUserCode",
		code: "NS-15-02",
		description: "NS-15-02 North Shore Hospital : Main Building, 02 Floor",
	},
	{
		id: "NS-15-03",
		domainCode: "endUserCode",
		code: "NS-15-03",
		description: "NS-15-03 North Shore Hospital : Main Building, 03 Floor",
	},
	{
		id: "NS-15-04",
		domainCode: "endUserCode",
		code: "NS-15-04",
		description: "NS-15-04 North Shore Hospital : Main Building, 04 Floor",
	},
	{
		id: "NS-15-05",
		domainCode: "endUserCode",
		code: "NS-15-05",
		description: "NS-15-05 North Shore Hospital : Main Building, 05 Floor",
	},
	{
		id: "NS-15-06",
		domainCode: "endUserCode",
		code: "NS-15-06",
		description: "NS-15-06 North Shore Hospital : Main Building, 06 Floor",
	},
	{
		id: "NS-15-07",
		domainCode: "endUserCode",
		code: "NS-15-07",
		description: "NS-15-07 North Shore Hospital : Main Building, 07 Floor",
	},
	{
		id: "NS-15-08",
		domainCode: "endUserCode",
		code: "NS-15-08",
		description: "NS-15-08 North Shore Hospital : Main Building, 08 Floor",
	},
	{
		id: "NS-15-09",
		domainCode: "endUserCode",
		code: "NS-15-09",
		description: "NS-15-09 North Shore Hospital : Main Building, 09 Floor",
	},
	{
		id: "NS-15-10",
		domainCode: "endUserCode",
		code: "NS-15-10",
		description: "NS-15-10 North Shore Hospital : Main Building, 10 Floor",
	},
	{
		id: "NS-16",
		domainCode: "endUserCode",
		code: "NS-16",
		description: "NS-16 North Shore Hospital : Kitchen/Dining",
	},
	{
		id: "NS-17",
		domainCode: "endUserCode",
		code: "NS-17",
		description:
			"NS-17 North Shore Hospital : Site Services Building/ Generator House",
	},
	{
		id: "NS-18",
		domainCode: "endUserCode",
		code: "NS-18",
		description: "NS-18 North Shore Hospital : Substation 2/ ESC Generator",
	},
	{
		id: "NS-19",
		domainCode: "endUserCode",
		code: "NS-19",
		description: "NS-19 North Shore Hospital : Crèche",
	},
	{
		id: "NS-20",
		domainCode: "endUserCode",
		code: "NS-20",
		description: "NS-20 North Shore Hospital : Gas Mains House",
	},
	{
		id: "NS-22",
		domainCode: "endUserCode",
		code: "NS-22",
		description: "NS-22 North Shore Hospital : Ginger Bread House",
	},
	{
		id: "NS-23",
		domainCode: "endUserCode",
		code: "NS-23",
		description:
			"NS-23 North Shore Hospital : Office accommodation for clinical support",
	},
	{
		id: "NS-24",
		domainCode: "endUserCode",
		code: "NS-24",
		description:
			"NS-24 North Shore Hospital : Renal Service - 122 Shakespeare Rd",
	},
	{
		id: "NS-25-LG",
		domainCode: "endUserCode",
		code: "NS-25-LG",
		description:
			"NS-25-LG North Shore Hospital : Lakeview, Lower Ground Floor",
	},
	{
		id: "NS-25-GR",
		domainCode: "endUserCode",
		code: "NS-25-GR",
		description: "NS-25-GR North Shore Hospital : Lakeview, Ground Floor",
	},
	{
		id: "NS-25-01",
		domainCode: "endUserCode",
		code: "NS-25-01",
		description: "NS-25-01 North Shore Hospital : Lakeview, 01 Floor",
	},
	{
		id: "NS-26",
		domainCode: "endUserCode",
		code: "NS-26",
		description: "NS-26 North Shore Hospital : Car Park Building",
	},
	{
		id: "NS-27",
		domainCode: "endUserCode",
		code: "NS-27",
		description:
			"NS-27 North Shore Hospital : Dialysis Centre - 132 Shakespeare Rd",
	},
	{
		id: "NS-28-01",
		domainCode: "endUserCode",
		code: "NS-28-01",
		description:
			"NS-28-01 North Shore Hospital : Elective Surgery Centre, 01 Floor",
	},
	{
		id: "NS-28-GR",
		domainCode: "endUserCode",
		code: "NS-28-GR",
		description:
			"NS-28-GR North Shore Hospital : Elective Surgery Centre, Ground Floor",
	},
	{
		id: "NS-29",
		domainCode: "endUserCode",
		code: "NS-29",
		description: "NS-29 North Shore Hospital : North Shore Gym",
	},
	{
		id: "NS-30",
		domainCode: "endUserCode",
		code: "NS-30",
		description:
			"NS-30 North Shore Hospital : He Puna Waiora - 132 Shakespeare Rd",
	},
	{
		id: "NS-31",
		domainCode: "endUserCode",
		code: "NS-31",
		description: "NS-31 North Shore Hospital : 44 Taharoto Road",
	},
	{
		id: "NS-32",
		domainCode: "endUserCode",
		code: "NS-32",
		description: "NS-32 North Shore Hospital : Whare Karaka",
	},
	{
		id: "NS-33",
		domainCode: "endUserCode",
		code: "NS-33",
		description:
			"NS-33 North Shore Hospital : 9 Karaka Street  Units 1 - 8 ",
	},
	{
		id: "NS-34",
		domainCode: "endUserCode",
		code: "NS-34",
		description: "NS-34 North Shore Hospital : North Shore Sky Bridge",
	},
	{
		id: "NS-35",
		domainCode: "endUserCode",
		code: "NS-35",
		description:
			"NS-35 North Shore Hospital : Waitemata Clinical Skills Centre",
	},
	{
		id: "NS-37 ",
		domainCode: "endUserCode",
		code: "NS-37 ",
		description: "NS-37 North Shore Hospital : 37 Taharoto Road",
	},
	{
		id: "WT-01",
		domainCode: "endUserCode",
		code: "WT-01",
		description: "WT-01 Waitakere Hospital : Woodford House",
	},
	{
		id: "WT-02",
		domainCode: "endUserCode",
		code: "WT-02",
		description: "WT-02 Waitakere Hospital : Building 2",
	},
	{
		id: "WT-03",
		domainCode: "endUserCode",
		code: "WT-03",
		description: "WT-03 Waitakere Hospital : Snelgar Building",
	},
	{
		id: "WT-04",
		domainCode: "endUserCode",
		code: "WT-04",
		description:
			"WT-04 Waitakere Hospital : Clinical / Surgical Skills training",
	},
	{
		id: "WT-05",
		domainCode: "endUserCode",
		code: "WT-05",
		description: "WT-05 Waitakere Hospital : Health West Building",
	},
	{
		id: "WT-06",
		domainCode: "endUserCode",
		code: "WT-06",
		description: "WT-06 Waitakere Hospital : Trade Workshop",
	},
	{
		id: "WT-07",
		domainCode: "endUserCode",
		code: "WT-07",
		description: "WT-07 Waitakere Hospital : Nikau Room",
	},
	{
		id: "WT-08",
		domainCode: "endUserCode",
		code: "WT-08",
		description: "WT-08 Waitakere Hospital : New Boiler House",
	},
	{
		id: "WT-09",
		domainCode: "endUserCode",
		code: "WT-09",
		description: "WT-09 Waitakere Hospital : Standby Generator House",
	},
	{
		id: "WT-10",
		domainCode: "endUserCode",
		code: "WT-10",
		description: "WT-10 Waitakere Hospital : Woodford Cottage",
	},
	{
		id: "WT-11",
		domainCode: "endUserCode",
		code: "WT-11",
		description: "WT-11 Waitakere Hospital : Te Atarau Mental Health Unit",
	},
	{
		id: "WT-12",
		domainCode: "endUserCode",
		code: "WT-12",
		description: "WT-12 Waitakere Hospital : Union Health Building ",
	},
	{
		id: "WT-14",
		domainCode: "endUserCode",
		code: "WT-14",
		description: "WT-14 Waitakere Hospital : Woodford Gardens",
	},
	{
		id: "WT-15",
		domainCode: "endUserCode",
		code: "WT-15",
		description: "WT-15 Waitakere Hospital : Greenhouse",
	},
	{
		id: "WT-16",
		domainCode: "endUserCode",
		code: "WT-16",
		description: "WT-16 Waitakere Hospital : Te Whare Oranga Building 1",
	},
	{
		id: "WT-18",
		domainCode: "endUserCode",
		code: "WT-18",
		description: "WT-18 Waitakere Hospital : Maternity",
	},
	{
		id: "WT-19",
		domainCode: "endUserCode",
		code: "WT-19",
		description: "WT-19 Waitakere Hospital : Te Whare Oranga building 2",
	},
	{
		id: "WT-20",
		domainCode: "endUserCode",
		code: "WT-20",
		description: "WT-20 Waitakere Hospital : Aratika",
	},
	{
		id: "WT-21-GR",
		domainCode: "endUserCode",
		code: "WT-21-GR",
		description:
			"WT-21-GR Waitakere Hospital : Main Building, Ground Floor",
	},
	{
		id: "WT-21-LG",
		domainCode: "endUserCode",
		code: "WT-21-LG",
		description:
			"WT-21-LG Waitakere Hospital : Main Building, Lower Ground Floor",
	},
	{
		id: "WT-22",
		domainCode: "endUserCode",
		code: "WT-22",
		description: "WT-22 Waitakere Hospital : WTH Haemodialysis",
	},
	{
		id: "WT-23",
		domainCode: "endUserCode",
		code: "WT-23",
		description: "WT-23 Waitakere Hospital : Waiatarau",
	},
	{
		id: "WT-24",
		domainCode: "endUserCode",
		code: "WT-24",
		description: "WT-24 Waitakere Hospital : New Emergency Department",
	},
	{
		id: "MC-01",
		domainCode: "endUserCode",
		code: "MC-01",
		description: "MC-01 Mason Clinic : Kauri, Totara",
	},
	{
		id: "MC-02",
		domainCode: "endUserCode",
		code: "MC-02",
		description: "MC-02 Mason Clinic : Kahikatea",
	},
	{
		id: "MC-04",
		domainCode: "endUserCode",
		code: "MC-04",
		description: "MC-04 Mason Clinic : Garage/Workshop/Equipment",
	},
	{
		id: "MC-05",
		domainCode: "endUserCode",
		code: "MC-05",
		description: "MC-05 Mason Clinic : Kowhai Centre",
	},
	{
		id: "MC-06",
		domainCode: "endUserCode",
		code: "MC-06",
		description: "MC-06 Mason Clinic : Swimming Pool Changing Room",
	},
	{
		id: "MC-07",
		domainCode: "endUserCode",
		code: "MC-07",
		description: "MC-07 Mason Clinic : Puriri",
	},
	{
		id: "MC-08",
		domainCode: "endUserCode",
		code: "MC-08",
		description: "MC-08 Mason Clinic : Rata",
	},
	{
		id: "MC-09",
		domainCode: "endUserCode",
		code: "MC-09",
		description: "MC-09 Mason Clinic : Tanekaha",
	},
	{
		id: "MC-10",
		domainCode: "endUserCode",
		code: "MC-10",
		description: "MC-10 Mason Clinic : Te Miro Community Building",
	},
	{
		id: "MC-11",
		domainCode: "endUserCode",
		code: "MC-11",
		description: "MC-11 Mason Clinic : Generator House",
	},
	{
		id: "MC-12",
		domainCode: "endUserCode",
		code: "MC-12",
		description: "MC-12 Mason Clinic : Tane Whakapiripiri",
	},
	{
		id: "MC-13",
		domainCode: "endUserCode",
		code: "MC-13",
		description: "MC-13 Mason Clinic : Pohutukawa",
	},
	{
		id: "MC-14",
		domainCode: "endUserCode",
		code: "MC-14",
		description: "MC-14 Mason Clinic : Rimu",
	},
	{
		id: "MC-15",
		domainCode: "endUserCode",
		code: "MC-15",
		description: "MC-15 Mason Clinic : Kurawaka",
	},
	{
		id: "MC-16",
		domainCode: "endUserCode",
		code: "MC-16",
		description: "MC-16 Mason Clinic : Puriri Pod",
	},
	{
		id: "MC-17",
		domainCode: "endUserCode",
		code: "MC-17",
		description: "MC-17 Mason Clinic : New 15 Bed Unit",
	},
	{
		id: "WC-01",
		domainCode: "endUserCode",
		code: "WC-01",
		description: "WC-01 Wilson Centre : Main Block",
	},
	{
		id: "WC-02",
		domainCode: "endUserCode",
		code: "WC-02",
		description: "WC-02 Wilson Home : School Block",
	},
	{
		id: "WC-03",
		domainCode: "endUserCode",
		code: "WC-03",
		description: "WC-03 Wilson Home : Assessment & treatment unit",
	},
	{
		id: "WC-04",
		domainCode: "endUserCode",
		code: "WC-04",
		description: "WC-04 Wilson Centre : Villas",
	},
	{
		id: "WC-06",
		domainCode: "endUserCode",
		code: "WC-06",
		description: "WC-06 Wilson Home : Chapel",
	},
	{
		id: "WC-07",
		domainCode: "endUserCode",
		code: "WC-07",
		description: "WC-07 Wilson Home : Gardener Shed",
	},
	{
		id: "WC-08",
		domainCode: "endUserCode",
		code: "WC-08",
		description: "WC-08 Wilson Home : The Bach (Parents Accommodation)",
	},
	{
		id: "WC-09",
		domainCode: "endUserCode",
		code: "WC-09",
		description: "WC-09 Wilson Home : Staff Flat",
	},
	{
		id: "WC-10",
		domainCode: "endUserCode",
		code: "WC-10",
		description: "WC-10 Wilson Home : Summer House",
	},
	{
		id: "WC-11",
		domainCode: "endUserCode",
		code: "WC-11",
		description: "WC-11 Wilson Home : Wilson Home Trust Office",
	},
	{
		id: "DC-01",
		domainCode: "endUserCode",
		code: "DC-01",
		description: "DC-01 Detox Centre : Pitman House (Regional Admin)",
	},
	{
		id: "DC-01-GR",
		domainCode: "endUserCode",
		code: "DC-01-GR",
		description: "DC-01-GR Detox Centre : Pitman House, Ground Floor",
	},
	{
		id: "DC-01-01",
		domainCode: "endUserCode",
		code: "DC-01-01",
		description: "DC-01-01 Detox Centre : Pitman House, 01 Floor",
	},
	{
		id: "DC-02",
		domainCode: "endUserCode",
		code: "DC-02",
		description: "DC-02 Detox Centre : CADS Central/TUPU/Altered High,",
	},
	{
		id: "DC-03",
		domainCode: "endUserCode",
		code: "DC-03",
		description:
			"DC-03 Detox Centre : CADS South, 17 Lambie Drive Building 4",
	},
	{
		id: "DC-04",
		domainCode: "endUserCode",
		code: "DC-04",
		description:
			"DC-04 Detox Centre : CADS South - Matariki (492 Great South Road)",
	},
	{
		id: "WW",
		domainCode: "endUserCode",
		code: "WW",
		description: "WW Warkworth Community Health",
	},
	{
		id: "WEL",
		domainCode: "endUserCode",
		code: "WEL",
		description: "WEL Wellsford Coast to Coast ",
	},
	{
		id: "HV",
		domainCode: "endUserCode",
		code: "HV",
		description: "HV Helensville Community Health",
	},
	{
		id: "RB",
		domainCode: "endUserCode",
		code: "RB",
		description: "RB Red Beach Community Health",
	},
	{
		id: "WLP",
		domainCode: "endUserCode",
		code: "WLP",
		description: "WLP 3 William Laurie Place, Albany",
	},
	{
		id: "WA",
		domainCode: "endUserCode",
		code: "WA",
		description: "WA Waimarino Building, 33 Paramount Drive, Henderson",
	},
	{
		id: "WO",
		domainCode: "endUserCode",
		code: "WO",
		description: "WO Whanau Ora House, Henderson",
	},
	{
		id: "TO",
		domainCode: "endUserCode",
		code: "TO",
		description: "TO Totara Health Building, 1 McCrae Way, New Lynn",
	},
	{
		id: "HBU",
		domainCode: "endUserCode",
		code: "HBU",
		description: "HBU Hyperbaric Unit, 91Calliope Rd, Devonport",
	},
	{
		id: "RU",
		domainCode: "endUserCode",
		code: "RU",
		description: "RU Renal Unit : 88-98 Apollo Drive",
	},
	{
		id: "ST-01-01",
		domainCode: "endUserCode",
		code: "ST-01-01",
		description: "ST-01-01 1 Shea Terrace : Corporate Building, ",
	},
	{
		id: "ST-02-01",
		domainCode: "endUserCode",
		code: "ST-02-01",
		description: "ST-02-01 3 Shea Terrace : Corporate Building, ",
	},
	{
		id: "ST-03-01",
		domainCode: "endUserCode",
		code: "ST-03-01",
		description: "ST-03-01 15 Shea Terrace : Corporate Building, 01 Floor",
	},
	{
		id: "ST-03-01",
		domainCode: "endUserCode",
		code: "ST-03-01",
		description: "ST-03-01 15 Shea Terrace : Corporate Building, 02 Floor",
	},
	{
		id: "ST-04-01",
		domainCode: "endUserCode",
		code: "ST-04-01",
		description: "ST-04-01 17 Shea Terrace : Corporate Building, ",
	},
	{
		id: "ST-04-01",
		domainCode: "endUserCode",
		code: "ST-04-01",
		description: "ST-04-01 17 Shea Terrace : Occupational Health Clinic",
	},
	{
		id: "CCDC-01",
		domainCode: "endUserCode",
		code: "CCDC-01",
		description:
			"CCDC-01 Community Children Dental Clinic : Edmonton Primary School",
	},
	{
		id: "CCDC-02",
		domainCode: "endUserCode",
		code: "CCDC-02",
		description:
			"CCDC-02 Community Children Dental Clinic : Glenfield Primary School",
	},
	{
		id: "CCDC-03",
		domainCode: "endUserCode",
		code: "CCDC-03",
		description:
			"CCDC-03 Community Children Dental Clinic : Henderson Intermediate School",
	},
	{
		id: "CCDC-04",
		domainCode: "endUserCode",
		code: "CCDC-04",
		description:
			"CCDC-04 Community Children Dental Clinic : Belmont Primary School",
	},
	{
		id: "CCDC-05",
		domainCode: "endUserCode",
		code: "CCDC-05",
		description:
			"CCDC-05 Community Children Dental Clinic : Northcross Intermediate School",
	},
	{
		id: "CCDC-06",
		domainCode: "endUserCode",
		code: "CCDC-06",
		description:
			"CCDC-06 Community Children Dental Clinic : Forrest Hill Primary School",
	},
	{
		id: "CCDC-07",
		domainCode: "endUserCode",
		code: "CCDC-07",
		description:
			"CCDC-07 Community Children Dental Clinic : Silverdale Primary School",
	},
	{
		id: "CCDC-08",
		domainCode: "endUserCode",
		code: "CCDC-08",
		description:
			"CCDC-08 Community Children Dental Clinic : Albany Junior High School",
	},
	{
		id: "CCDC-09",
		domainCode: "endUserCode",
		code: "CCDC-09",
		description:
			"CCDC-09 Community Children Dental Clinic : Glen Eden Intermediate School",
	},
	{
		id: "CCDC-10",
		domainCode: "endUserCode",
		code: "CCDC-10",
		description:
			"CCDC-10 Community Children Dental Clinic : Westgate Community Clinic",
	},
	{
		id: "CCDC-11",
		domainCode: "endUserCode",
		code: "CCDC-11",
		description:
			"CCDC-11 Community Children Dental Clinic : Birkenhead Primary School",
	},
	{
		id: "TDU-01",
		domainCode: "endUserCode",
		code: "TDU-01",
		description: "TDU-01 Temporary Dental Unit : Teuila",
	},
	{
		id: "TDU-02",
		domainCode: "endUserCode",
		code: "TDU-02",
		description: "TDU-02 Temporary Dental Unit : Karamea",
	},
	{
		id: "TDU-03",
		domainCode: "endUserCode",
		code: "TDU-03",
		description: "TDU-03 Temporary Dental Unit : Aroha",
	},
	{
		id: "TDU-04",
		domainCode: "endUserCode",
		code: "TDU-04",
		description: "TDU-04 Temporary Dental Unit : Kaipatiki",
	},
	{
		id: "TDU-05",
		domainCode: "endUserCode",
		code: "TDU-05",
		description: "TDU-05 Temporary Dental Unit : Pohutukawa",
	},
	{
		id: "TDU-06",
		domainCode: "endUserCode",
		code: "TDU-06",
		description: "TDU-06 Temporary Dental Unit : Tiri Tiri Matangi",
	},
	{
		id: "TDU-07",
		domainCode: "endUserCode",
		code: "TDU-07",
		description: "TDU-07 Temporary Dental Unit : Tiare",
	},
	{
		id: "TDU-08",
		domainCode: "endUserCode",
		code: "TDU-08",
		description: "TDU-08 Temporary Dental Unit : Pupuke",
	},
	{
		id: "TDU-09",
		domainCode: "endUserCode",
		code: "TDU-09",
		description: "TDU-09 Temporary Dental Unit : Motutapu",
	},
	{
		id: "TDU-10",
		domainCode: "endUserCode",
		code: "TDU-10",
		description: "TDU-10 Temporary Dental Unit : Fantail",
	},
	{
		id: "TDU-11",
		domainCode: "endUserCode",
		code: "TDU-11",
		description: "TDU-11 Temporary Dental Unit : Rosella",
	},
	{
		id: "TDU-12",
		domainCode: "endUserCode",
		code: "TDU-12",
		description: "TDU-12 Temporary Dental Unit : Pakiri Niho",
	},
	{
		id: "TDU-13",
		domainCode: "endUserCode",
		code: "TDU-13",
		description: "TDU-13 Temporary Dental Unit : Kokako",
	},
	{
		id: "TDU-14",
		domainCode: "endUserCode",
		code: "TDU-14",
		description: "TDU-14 Temporary Dental Unit : Kauri",
	},
	{
		id: "TDU-15",
		domainCode: "endUserCode",
		code: "TDU-15",
		description: "TDU-15 Temporary Dental Unit : Totara",
	},
];

export const SERVICES = [
	{
		id: "01 - Corporate",
		domainCode: "services",
		code: "01 - Corporate",
		description: "01 - Corporate",
	},
	{
		id: "02 - Elective Surgery Centre",
		domainCode: "services",
		code: "02 - Elective Surgery Centre",
		description: "02 - Elective Surgery Centre",
	},
	{
		id: "03 - HIG/IT/i3",
		domainCode: "services",
		code: "03 - HIG/IT/i3",
		description: "03 - HIG/IT/i3",
	},
	{
		id: "04 - Facilities & Development",
		domainCode: "services",
		code: "04 - Facilities & Development",
		description: "04 - Facilities & Development",
	},
	{
		id: "05 - Hospital Operations",
		domainCode: "services",
		code: "05 - Hospital Operations",
		description: "05 - Hospital Operations",
	},
	{
		id: "06 - Mental Health",
		domainCode: "services",
		code: "06 - Mental Health",
		description: "06 - Mental Health",
	},
	{
		id: "07- Funding and Planning",
		domainCode: "services",
		code: "07- Funding and Planning",
		description: "07- Funding and Planning",
	},
	{
		id: "08 - Surgical & Ambulatory",
		domainCode: "services",
		code: "08 - Surgical & Ambulatory",
		description: "08 - Surgical & Ambulatory",
	},
	{
		id: "09 - Child, Women & Family",
		domainCode: "services",
		code: "09 - Child, Women & Family",
		description: "09 - Child, Women & Family",
	},
	{
		id: "10 - Acute & Emergency",
		domainCode: "services",
		code: "10 - Acute & Emergency",
		description: "10 - Acute & Emergency",
	},
	{
		id: "11 - Sub Specialty",
		domainCode: "services",
		code: "11 - Sub Specialty",
		description: "11 - Sub Specialty",
	},
	{
		id: "12 - Facilities Management",
		domainCode: "services",
		code: "12 - Facilities Management",
		description: "12 - Facilities Management",
	},
	{
		id: "13 - SCPG",
		domainCode: "services",
		code: "13 - SCPG",
		description: "13 - SCPG",
	},
	{
		id: "14 - Director of Hospital Services",
		domainCode: "services",
		code: "14 - Director of Hospital Services",
		description: "14 - Director of Hospital Services",
	},
	{
		id: "15 - Diagnostic and Clinical Support",
		domainCode: "services",
		code: "15 - Diagnostic and Clinical Support",
		description: "15 - Diagnostic and Clinical Support",
	},
	{
		id: "16 - Elective Outpatients",
		domainCode: "services",
		code: "16 - Elective Outpatients",
		description: "16 - Elective Outpatients",
	},
	{
		id: "17 - Regional Dental Services",
		domainCode: "services",
		code: "17 - Regional Dental Services",
		description: "17 - Regional Dental Services",
	},
	{
		id: "18 - Population Health Services",
		domainCode: "services",
		code: "18 - Population Health Services",
		description: "18 - Population Health Services",
	},
	{
		id: "19 - PHSSS – Uri Ririki/EBSHS/Regn Bowel Support",
		domainCode: "services",
		code: "19 - PHSSS – Uri Ririki/EBSHS/Regn Bowel Support",
		description: "19 - PHSSS – Uri Ririki/EBSHS/Regn Bowel Support",
	},
	{
		id: "20 - Asian Health",
		domainCode: "services",
		code: "20 - Asian Health",
		description: "20 - Asian Health",
	},
	{
		id: "21 - Pacific Health",
		domainCode: "services",
		code: "21 - Pacific Health",
		description: "21 - Pacific Health",
	},
];

export const LOOKUPS = [
	...RCS,
	...PROJECT_TYPE,
	...REQUEST_DETAILS,
	...CAPABILITY_TYPE,
	...CURRENCY,
	...COST_TYPE,
	...PATIENT_STAFF_IMPACT,
	...LIKELIHOOD_FAILURE,
	...SERVICE_IMPACT,
	...WEIGHTING,
	...CONSEQUENCES,
	...LIKELIHOOD_CONSEQUENCE,
	...ORACLE_SETUP_TYPE,
	...END_USER_CODE,
	...BUDGET_CATEGORIES,
	...SERVICES,
	{
		id: "l14",
		domainCode: "YN",
		code: "Y",
		description: "Yes",
	},
	{
		id: "l15",
		domainCode: "YN",
		code: "N",
		description: "No",
	},
	{
		id: "l16",
		domainCode: "asset",
		code: "123456",
		description: "123456",
	},
	{
		id: "l17",
		domainCode: "asset",
		code: "654321",
		description: "654321",
	},
	{
		id: "l18",
		domainCode: "location",
		code: "NSH",
		description: "NSH",
	},
	{
		id: "l19",
		domainCode: "location",
		code: "WTH",
		description: "WTH",
	},
	{
		id: "l20",
		domainCode: "assetFate",
		code: "dispose",
		description: "Dispose",
	},
	{
		id: "l21",
		domainCode: "assetFate",
		code: "decommision",
		description: "Decommission",
	},
	{
		id: "l22",
		domainCode: "assetFate",
		code: "continue",
		description: "Continue until failure",
	},
];
